<template>
    <div ref="leafletMap" style="height: 500px; z-index: 1;"></div>
</template>

<script>
    import L from 'leaflet';

    export default {
        props: {
            plazasSeleccionadas: {
                type: Array,
                required: false
            },
            continuarConCompra: {
                type: Boolean,
                required: false
            },
            svgRendered: {
                type: SVGSVGElement,
                required: true
            },
            originalColor: {
                type: String,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                map: null,
            };
        },
        mounted() {
            this.renderSvg();
        },
        watch: {
            disabled(newVal) {
                this.toggleMapInteractivity(newVal);
            },
            clonedPlazasSeleccionadas(newValue, oldValue) {
                const plazaQuitada = oldValue.filter(({ id: newPlazaId }) => !newValue.some(({ id: oldPlazaId }) => newPlazaId === oldPlazaId));
                if (plazaQuitada) {
                    plazaQuitada.forEach(plaza => {
                        const circle = document.querySelector(`[id^="butaca-${plaza.svg_id}-"]`);

                        if (circle) {
                            if (plaza.precios?.length > 0) {
                                circle.setAttribute('fill', plaza.originalColor ?? this.originalColor);
                            } else {
                                circle.setAttribute('fill', 'gray');
                            }
                            circle.setAttribute('seleccionado', 'false');
                        }
                    });
                }
            }
        },
        computed: {
            clonedPlazasSeleccionadas() {
                return this.plazasSeleccionadas ? [...this.plazasSeleccionadas] : null;
            }
        },
        methods: {
            renderSvg() {            
                const width = parseInt(this.svgRendered.getAttribute('width'));
                const height = parseInt(this.svgRendered.getAttribute('height'));

                const bounds = [[0, 0], [height, width]];

                // Inicializar el mapa
                this.map = L.map(this.$refs.leafletMap, {
                    wheelPxPerZoomLevel: 100,
                    minZoom: -2,
                    maxZoom: 2,
                    crs: L.CRS.Simple,
                    maxBounds: bounds,
                    maxBoundsViscosity: 1,
                    attributionControl: false,
                    zoomSnap: 0.25,
                    preferCanvas: true
                });

                this.map.invalidateSize();

                this.map.on('movestart', () => {
                    this.$emit('isPanning', true);
                });

                this.map.on('moveend', () => {
                    this.$emit('isPanning', false);
                });

                L.svgOverlay(this.svgRendered, bounds, {
                    interactive: true
                }).addTo(this.map);

                this.map.setView([height / 2, width / 2], -1.6);
            },
            toggleMapInteractivity(isDisabled) {
                if (this.map) {
                    if (isDisabled) {
                        this.map.dragging.disable();      
                        this.map.touchZoom.disable();      
                        this.map.doubleClickZoom.disable(); 
                        this.map.scrollWheelZoom.disable(); 
                        this.map.boxZoom.disable();        
                        this.map.keyboard.disable();      
                        this.map.tap && this.map.tap.disable(); 
                    } else {
                        this.map.dragging.enable();       
                        this.map.touchZoom.enable();      
                        this.map.doubleClickZoom.enable();  
                        this.map.scrollWheelZoom.enable();  
                        this.map.boxZoom.enable();         
                        this.map.keyboard.enable();        
                        this.map.tap && this.map.tap.enable(); 
                    }
                }
            }
        },
    };
</script>
